import { getAuthHeaders } from 'ui/screens/SignIn/helpers'
import { callApi } from 'domains/common/callApi'

/**
 * Call the Applesauce API, with authentication handling
 * @param {object} axiosOptions - the options to pass to axios
 * @param {string} method - the method to use for the call, e.g. GET, POST, PATCH, DELETE
 * @param {object} params - the parameters to pass to the call
 * @param {string} url - the url to make the call to
 *
 * @returns {Promise<*>} the response from the API call
 */

export const callApplesauceApi = ({ axiosOptions, method, params, url }) =>
  callApi({
    axiosOptions,
    getAuthHeaders,
    method,
    params,
    url,
  })
